module.exports = __webpack_public_path__ + "static/sims-9d4fbaf4632e6dbfe3063adefa4e6106.jpg";